import type { User } from '../Types/interfaces';

const isNullOrWhiteSpace = (value?: string | number): boolean => {
  if (typeof value === 'string') {
    return !value || value.trim() === '';
  }

  return true;
};

export const isUserDataFilled = (user: User) => {
  if (!user) return false;

  const requiredFields: (keyof User)[] = [
    'email',
    'firstName',
    'lastName',
    'phoneNumber',
    'jobTitle',
  ];

  return requiredFields.every((field) => !isNullOrWhiteSpace(user[field]));
};
